import { useState, useEffect } from "react";
import OrderStatusChart from "./OrderStatusChart";

const MainHeader = ({ orders }) => {
  const [pendingOrder, setPendingOrder] = useState(0);
  const [processingOrder, setProcessingOrder] = useState(0);
  const [completeOrder, setCompleteOrder] = useState(0);
  const [statusCounts, setStatusCounter] = useState(null);

  useEffect(() => {
    setPendingOrder(orders.filter((order) => order.status === 1).length);
    setProcessingOrder(orders.filter((order) => order.status === 2).length);
    setCompleteOrder(orders.filter((order) => order.status === 3).length);
  }, [orders]);
  useEffect(() => {
    setStatusCounter({
      "طلبات جديدة": pendingOrder,
      "طلبات قيد التنفيذ": processingOrder,
      "طلبات مكتلمة": completeOrder,
    });
  }, [pendingOrder, processingOrder, completeOrder]);
  return (
    <>
      <header className="bg-gradient-to-r from-rose-50 via-sky-50 to-teal-50 py-24 flex items-center justify-center border-b">
        <div className="flex">
          <div className="flex h-auto w-full max-w-7xl flex-col items-center justify-around space-x-4 space-y-2 py-12 md:flex-row lg:h-60">
            <div className="flex flex-col items-center justify-center py-8">
              {statusCounts ? (
                <OrderStatusChart
                  className="my-8"
                  data={Object.entries(statusCounts).map(([status, count]) => ({
                    status,
                    count,
                  }))}
                />
              ) : (
                ""
              )}

              <h2 className="font-bold text-xl text-center text-gray-800 py-4">
                تفاصيل الطلبات لأخر 24 ساعة
                <br />
                <span>عدد الطلبات الكلي هو {orders.length}</span>
              </h2>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default MainHeader;
